import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'

import MainReducer from '../containers/main/reducer'
import LoginReducer from '../containers/login/reducer'
import DashboardReducer from '../containers/dashboard/reducer'
import ListboardReducer from '../containers/listboard/reducer'

const reducers = {}
reducers['router'] = routerReducer
reducers[MainReducer.NAME] = MainReducer.reducer
reducers[LoginReducer.NAME] = LoginReducer.reducer
reducers[DashboardReducer.NAME] = DashboardReducer.reducer
reducers[ListboardReducer.NAME] = ListboardReducer.reducer

export default combineReducers(reducers)

export const whitelist = [
    MainReducer.NAME
]



// WEBPACK FOOTER //
// ./src/reducers/index.js